import { IAppState } from '../../redux';
import { EPaymentStatus } from '../../types/reducers/depositAccount';

export const selectIsRecommendedPackagePaymentStatusCheckInProgress = (state: IAppState): boolean => {
  const status = state.depositAccount.recommendedPackagePaymentStatus;

  return Boolean(status) && status !== EPaymentStatus.Success;
};
